
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stock-screener/[screen]",
      function () {
        return require("private-next-pages/stock-screener/[screen].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stock-screener/[screen]"])
      });
    }
  